var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"height":"40","src":require('@/assets/logo_large.svg'),"alt":"rentalios-logo"}})]),_c('div',{staticClass:"content-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }